<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  methods: {
    getTileThumbnailUrl: Fandom.getTileThumbnailUrl
  },
  computed: {
    thumbnailUrl() {
      return this.getTileThumbnailUrl();
    }
  }
};
</script>

<template>
  <div :style="theme" :class="contentType" v-easyadmin="easyadminId" class="rounded-borders overflow-hidden tile-shadow themed-item d-flex flex-column">
    <div class="bg-cover-center w-100 ar-16by9" v-if="thumbnailUrl" :style="{'background-image': thumbnailUrl}"></div>
    <div class="d-flex h-100 w-100 flex-column text-center">
      <div class="d-flex flex-column p-4">
        <span class="font-weight-bold font-family-base h6" :class="{'mb-2': content.subtitle}">{{content.title}}</span>
        <span class="font-weight-normal font-family-base h6 text-gray-500 mb-2">{{content.subtitle}}</span>
        <div class="description pt-3" v-html="content.description"></div>
      </div>
      <div class="font-weight-bold date mb-0 mt-auto w-100 px-3 py-2" v-html="content.date"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.rounded-borders {
  border-radius: .375rem;
  }

.description,
.description ::v-deep p {
  @include font-size(1rem);
  line-height: 1.4;
}

.date {
  @include font-size(1rem);
  background-color:$gray-250; 
}
</style>
